import { useSnackbarStore } from '../store/useSnackbarStore';
import { ISnackbarService } from './ISnackbarService';

export class SnackbarServiceImpl implements ISnackbarService {
  private snackbarStore: typeof useSnackbarStore;

  public constructor(snackbarStore: typeof useSnackbarStore) {
    this.snackbarStore = snackbarStore;
  }

  public showMessage(message: string): void {
    this.snackbarStore.getState().showSnackbar(message);
  }
}
